/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Bribery_And_WageringInputs */



/**
* | output |
* | --- |
* | "Bribery and Wagering" |
*
* @param {Sanction_Sub_Bribery_And_WageringInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_bribery_and_wagering = /** @type {((inputs?: Sanction_Sub_Bribery_And_WageringInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Bribery_And_WageringInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corruption et Paris")
	if (locale === "es") return /** @type {LocalizedString} */ ("Soborno y Apuestas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Suborno e Apostas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Corruzione e Scommesse")
	return /** @type {LocalizedString} */ ("Bribery and Wagering")
});